<div [ngClass]="{panelClass,'wrap-container': isUserField || isAccountField}">
  @if (defaultField?.type==='constant_property' && allowValueEntry && !useCurrentUser && !useCurrentAccount) {
    <constant-field
      [constant_value]="defaultField.default_value"
      [constant_property]="constantProperty"
      (constant_changed)="defaultField.default_value = $event;"
      (change_complete)="defaultField.default_value = $event;"
      [auto_class]="panelClass"
      [placeholder]="placeholder"
      class="constant-field"
    ></constant-field>
  }

  @if (defaultField?.type==='component_type' && ctCtDict[defaultField.id]) {
    @if (ctCtDict[defaultField.id]?.isUnique) {
      <select-search-component
        (selectionChange)="onComponentChanged($event);"
        [api_model]="'component'"
        [compareFunctionName]="'compareById'"
        [custom_filters]="componentFilters"
        [allow_none]="true"
        [value]="defaultField.default_value">
      </select-search-component>
    }
    @if (ctCtDict[defaultField.id] && !ctCtDict[defaultField.id].isUnique) {
      <select-many-search-component
        (selectionChangeComplete)="onComponentChanged($event);"
        [api_model]="'component'"
        [custom_filters]="componentFilters"
        [compareFunctionName]="'compareById'"
        [value]="defaultField.default_value">
      </select-many-search-component>
    }
  }

  @if (isUserField) {
    <div class="user-field-options">
      <mat-checkbox
        [(ngModel)]="useCurrentUser"
        (change)="onUseCurrentUserChange($event.checked)"
        class="current-user-checkbox">
        Default to current user
      </mat-checkbox>
    </div>
  }

  @if (isAccountField) {
    <div class="user-field-options">
      <mat-checkbox
        [(ngModel)]="useCurrentAccount"
        (change)="onUseCurrentAccountChange($event.checked)"
        class="current-user-checkbox">
        Default to current account
      </mat-checkbox>
    </div>
  }

  @if (defaultField?.type==='constant_property' && !allowValueEntry) {
    <div class="placeholder">{{placeholder}}</div>
  }
</div>
